import { ValidatorIjja01IntKatalogJahrgaengeJahrgangAsdKatalog } from '../../../asd/validate/intKataloge/ValidatorIjja01IntKatalogJahrgaengeJahrgangAsdKatalog';
import type { Supplier } from '../../../java/util/function/Supplier';
import { Class } from '../../../java/lang/Class';
import { ValidatorKontext } from '../../../asd/validate/ValidatorKontext';
import { Validator } from '../../../asd/validate/Validator';

export class ValidatorIjja00IntKatalogJahrgaengeJahrgangAsdKatalog extends Validator {

	private readonly _idKatalog: Supplier<number | null>;


	/**
	 * @param idKatalog   ID
	 * @param kontext	  Kontext
	 */
	public constructor(idKatalog: Supplier<number | null>, kontext: ValidatorKontext) {
		super(kontext);
		this._idKatalog = idKatalog;
		this._validatoren.add(new ValidatorIjja01IntKatalogJahrgaengeJahrgangAsdKatalog(this.getNotNullSupplierLong(idKatalog), kontext));
	}

	protected pruefe(): boolean {
		if (null === this._idKatalog.get()) {
			this.addFehler(0, "Jahrgang ASD-Kürzel: Kein Wert vorhanden.");
			return false;
		}
		return true;
	}

	transpilerCanonicalName(): string {
		return 'de.svws_nrw.asd.validate.intKataloge.ValidatorIjja00IntKatalogJahrgaengeJahrgangAsdKatalog';
	}

	isTranspiledInstanceOf(name: string): boolean {
		return ['de.svws_nrw.asd.validate.intKataloge.ValidatorIjja00IntKatalogJahrgaengeJahrgangAsdKatalog', 'de.svws_nrw.asd.validate.BasicValidator', 'de.svws_nrw.asd.validate.Validator'].includes(name);
	}

	public static readonly class = new Class<ValidatorIjja00IntKatalogJahrgaengeJahrgangAsdKatalog>('de.svws_nrw.asd.validate.intKataloge.ValidatorIjja00IntKatalogJahrgaengeJahrgangAsdKatalog');

}

export function cast_de_svws_nrw_asd_validate_intKataloge_ValidatorIjja00IntKatalogJahrgaengeJahrgangAsdKatalog(obj: unknown): ValidatorIjja00IntKatalogJahrgaengeJahrgangAsdKatalog {
	return obj as ValidatorIjja00IntKatalogJahrgaengeJahrgangAsdKatalog;
}
